import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
// import Catalog from '../views/Catalog.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/insert',
    name: 'Insert',
    // route level code-splitting
    // this generates a separate chunk (insert.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "insert" */ '../views/Insert.vue')
  },
  {
    path: '/check',
    name: 'Check',
    // route level code-splitting
    // this generates a separate chunk (check.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "check" */ '../views/Check.vue')
  },
  {
    path: '/validate/:id/:code',
    name: 'Validate',
    // route level code-splitting
    // this generates a separate chunk (validate.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "validate" */ '../views/Validate.vue'),
    props: true,
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
